module.exports = __webpack_public_path__ + "assets/fonts/phone.a7e5591f.svg";